import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Row, Col } from "reactstrap";
import { moneda } from "./pagosCxpPDF";

// (2026-10) Huara de una entrada de proceso: precio extra por pieza que se
// suma a la maquila en su nota de CxP. nota = { folio, idEntrada, piezas,
// precio, precioHuara, total, abonado, impuestos }.
function ModalHuara({ isOpen, toggle, nota, onSaved }) {
  const [precio, setPrecio] = useState(0);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (isOpen && nota) setPrecio(nota.precioHuara || 0);
  }, [isOpen, nota]);

  if (!nota) return null;
  const piezas = Number(nota.piezas || 0);
  const importeHuara = Math.round(Number(precio || 0) * piezas * 100) / 100;
  // (2026-10) el IVA puede ir sólo sobre la parte facturada (facturaParcial)
  const tasa = Number(nota.impuestos || 0) / 100;
  const subtotal = nota.subtotal != null ? Number(nota.subtotal) : Number(nota.total || 0) / (1 + tasa);
  const nuevoSubtotal = subtotal - Number(nota.importeHuara || 0) + importeHuara;
  const baseIva =
    nota.facturaParcial === "Si" ? Math.min(Number(nota.importeFacturado || 0), nuevoSubtotal) : nuevoSubtotal;
  const nuevoTotal = nuevoSubtotal + baseIva * tasa;
  const muyBajo = nuevoTotal < Number(nota.abonado || 0) - 0.01;

  const guardar = async () => {
    if (Number(precio) < 0) return Swal.fire("Atención", "El precio no puede ser negativo", "warning");
    setGuardando(true);
    try {
      const { data } = await axios.patch(
        `${process.env.REACT_APP_URL_CXP_PAGOS}Huara/${nota.idEntrada}`,
        { precioHuara: Number(precio || 0) },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      Swal.fire("Listo", "Huara guardada; la nota ya trae el nuevo total", "success");
      toggle();
      if (onSaved) onSaved(data);
    } catch (err) {
      Swal.fire("Error", err.response?.data?.message || "No se pudo guardar la huara", "error");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Huara · Nota {nota.folio}</ModalHeader>
      <ModalBody>
        <p className="mb-2">
          Se paga por pieza igual que la maquila y se suma a la nota del taller.
        </p>
        <Row>
          <Col md={6}>
            <Label>Piezas</Label>
            <Input value={piezas} disabled />
          </Col>
          <Col md={6}>
            <Label>Precio maquila</Label>
            <Input value={moneda(nota.precio)} disabled />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={6}>
            <Label>Precio huara por pieza</Label>
            <Input
              type="number"
              min="0"
              step="any"
              value={precio}
              onChange={(e) => setPrecio(e.target.value)}
              autoFocus
            />
          </Col>
          <Col md={6}>
            <Label>Importe huara</Label>
            <Input value={moneda(importeHuara)} disabled />
          </Col>
        </Row>
        <br />
        <h5 style={{ textAlign: "right" }}>
          Total de la nota: {moneda(nota.total)} → <b>{moneda(nuevoTotal)}</b>
        </h5>
        {muyBajo ? (
          <p className="text-danger" style={{ textAlign: "right" }}>
            A la nota ya se le abonaron {moneda(nota.abonado)}; el total no puede quedar abajo de eso.
          </p>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={guardar} disabled={guardando || muyBajo}>
          {guardando ? "Guardando..." : "Guardar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalHuara;
